import gql from 'graphql-tag'
import client from '@stores/apollo'

const unseatedCount = async (
  assignmentPlanId: string,
  geoLocationId: string | undefined,
  checked: boolean
) => {
  return client.gql
    .query({
      query,
      variables: {
        assignmentPlanId,
        keyValueFilters: checked ? [{ key: 'GeoLocationId', value: geoLocationId }] : [],
      },
    })
    .then((data) => data.data)
}

const query = gql`
  query unseatedCounts($assignmentPlanId: ID, $keyValueFilters: [EmployeeKeyValueFiltersInput]) {
    viewer {
      company {
        employees(AssignmentPlanId: $assignmentPlanId, keyValueFilters: $keyValueFilters) {
          counters {
            employees
            unseated
          }
        }
      }
    }
  }
`

export default unseatedCount
